import type { ReactNode } from 'react';

export const symbol_border_color: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140 0q-24.75 0-42.37-17.88Q80-35.77 80-60.88 80-86 97.92-103.5 115.84-121 141-121h679q24.75 0 42.38 17.68Q880-85.65 880-60.82 880-36 862.08-18T819 0H140Zm80-301h44l391-391-22-22-22-22-391 391v44Zm-60 29.94v-84.93q0-6.01 2-11.51t7-10.5l485-485q9-9 20-13t22-4q11 0 22.5 4t19.5 13l44 44q9 8 13.5 19.5t4.5 22.85q0 10.65-4.3 21.61-4.31 10.97-13.7 20.04L297-250q-5 5-10.22 7-5.21 2-10.78 2h-85.67q-12.89 0-21.61-8.64-8.72-8.65-8.72-21.42ZM736-778l-41-41 41 41Zm-81 86-22-22-22-22 44 44Z"
		/>
	</svg>
);
